import axios from 'axios';
import qs from 'query-string';

const instance = axios.create({
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

export function addToCart(variantId, quantity = 1) {
  return instance.post('/cart/add.js', { id: variantId, quantity })
    .then(resp => resp.data)
    .then(fetchCart);
}

export function updateQuantity(variantId, quantity = 1) {
  return instance.post('/cart/change.js', { line: variantId, quantity })
    .then(resp => resp.data);
}

export function fetchCart() {
  return instance.get('/cart.js')
    .then(res => res.data);
}

export function fetchSizeGuide(shop, tags) {
  const params = qs.stringify({ shop, tags });

  return axios.get(`https://sizeguides.eastsideco.io/api/v1/size_guides?${params}`)
    .then(res => res.data);
}


// WEBPACK FOOTER //
// ./assets/scripts/redux/service.js